import { LocaleKey } from '../i18n/config'

export const detailTitle = 'emailVerification.detailTitle'

type BulletPointType = { title: LocaleKey }

export const DETAIL_BULLET_POINTS_DEFAULT: BulletPointType[] = [
  {
    title: 'emailVerification.bulletPoint.register'
  },
  {
    title: 'emailVerification.bulletPoint.donors'
  },
  {
    title: 'emailVerification.bulletPoint.donations'
  },
  {
    title: 'emailVerification.bulletPoint.discount'
  },
  {
    title: 'emailVerification.bulletPoint.grow'
  },
  {
    title: 'emailVerification.bulletPoint.access'
  },
  {
    title: 'emailVerification.bulletPoint.receive'
  }
]

export const VERIFICATION_DATA = {
  backButtonTitle: 'emailVerification.verificationData.backButtonTitle',
  mainButtonTitle: 'emailVerification.verificationData.mainButtonTitle',
  title: 'emailVerification.verificationData.title'
} as const
